import { useState, useEffect } from 'react'
import { Col, Form, Row } from 'react-bootstrap'
import { MenuComponent } from '../../../../../../_metronic/assets/ts/components'
import { initialQueryState, KTSVG } from '../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useQueryResponse } from '../../core/QueryResponseProvider'

const RolesListFilter = () => {
  const { state, updateState } = useQueryRequest()
  const { isLoading } = useQueryResponse()
  const [isModelOpen, setIsModelOpen] = useState(false)
  const [requestData, setRequestData] = useState<any>({})
  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])
  const resetData = () => {
    setRequestData({})
    updateState({ filter: undefined, ...initialQueryState })
    setIsModelOpen(false)
  }
  const filterData = () => {
    updateState({
      filter: requestData,
      ...initialQueryState,
      page: 1,
    })
    setIsModelOpen(false)
  }
  return (
    <>
      <button
        disabled={isLoading}
        type='button'
        className='btn btn-light-primary me-3'
        onClick={() => {
          setIsModelOpen(!isModelOpen)
        }}
      >
        <KTSVG path='/media/icons/duotune/general/gen031.svg' className='svg-icon-2' />
        Filter
      </button>

      <div
        className={`menu menu-sub menu-sub-dropdown w-700px w-md-600px position-absolute ${
          isModelOpen ? 'd-block' : 'd-none'
        }`}
      >
        <div className='px-7 py-5'>
          <div className='fs-5 text-dark fw-bolder'>Filter Options</div>
        </div>
        <div className='separator border-gray-200'></div>

        <div className='px-7 py-5' data-kt-user-table-filter='form'>
          <Row className='mb-5'>
            <Col xs={6}>
              <Form.Group className='mb-3'>
                <Form.Label className='form-label'>Role Name</Form.Label>
                <Form.Control
                  type='text'
                  className='form-control-solid'
                  placeholder='Role Name'
                  onChange={(e: any) => {
                    setRequestData({ ...requestData, name: e.target.value })
                  }}
                  value={requestData?.name ?? ''}
                />
              </Form.Group>
            </Col>

            <Col xs={6}>
              <Form.Group className='mb-3'>
                <Form.Label className='form-label'>Status</Form.Label>
                <Form.Select
                  className='form-control-solid border-0'
                  onChange={(e: any) => {
                    setRequestData({ ...requestData, status: e.target.value })
                  }}
                  value={requestData?.status ?? ''}
                >
                  <option value=''>All</option>
                  <option value='1'>Active</option>
                  <option value='0'>Inactive</option>
                </Form.Select>
              </Form.Group>
            </Col>
          </Row>
          <div className='d-flex justify-content-end gap-4'>
          <button
              type='button'
              disabled={isLoading}
              onClick={filterData}
              className='btn btn-primary fw-bold px-6'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='filter'
            >
              Apply
            </button>
            <button
              type='button'
              disabled={isLoading}
              onClick={resetData}
              className='btn btn-light btn-active-light-primary fw-bold px-6 me-5'
              data-kt-menu-dismiss='true'
              data-kt-user-table-filter='reset'
            >
              Reset
            </button>           
          </div>
        </div>
      </div>
    </>
  )
}
export { RolesListFilter }